export function formatterTime (s) {
    let duration = ''
    let day = Math.floor(s / (24 * 3600)) // Math.floor()向下取整 
    let hour = Math.floor((s - day * 24 * 3600) / 3600)
    let minute = Math.floor((s - day * 24 * 3600 - hour * 3600) / 60)
    let second = s - day * 24 * 3600 - hour * 3600 - minute * 60
    if (day > 0)
        duration += `${day}天`
    if (hour > 0)
        duration += `${hour}小时`
    if (minute > 0)
        duration += `${minute}分`
    if (second > 0)
        duration += `${second}秒`
    return duration
}